export const
    PIVOT_CENTER = 'center',
    PIVOT_TOP_LEFT = 'topLeft',
    PIVOT_TOP_RIGHT = 'topRight',
    PIVOT_BOTTOM_LEFT = 'bottomLeft',
    PIVOT_BOTTOM_RIGHT = 'bottomRight'
;